import script from "./beamer-whats-new-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./beamer-whats-new-button.vue?vue&type=script&setup=true&lang=ts"

import "./beamer-whats-new-button.vue?vue&type=style&index=0&id=e10052f0&lang=css"

const __exports__ = script;

export default __exports__